import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Tanggal Dibuat", -1)
const _hoisted_5 = { class: "my-1 font-normal" }
const _hoisted_6 = { class: "text-gray-lp-500" }
const _hoisted_7 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Tanggal Diubah", -1)
const _hoisted_9 = { class: "my-1 font-normal" }
const _hoisted_10 = { class: "text-gray-lp-500" }
const _hoisted_11 = { class: "inline-flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.title,
    loading: _ctx.apiGetData.loading,
    error: !!_ctx.apiGetData.errorType,
    errorType: _ctx.apiGetData.errorType,
    onTryAgain: _ctx.fetchDetail
  }, {
    data: _withCtx(() => [
      _createVNode(_component_DataWrapper, {
        label: "ID",
        value: _ctx.detail.id
      }, null, 8, ["value"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          class: "w-6/12",
          label: "Nama Pengguna",
          value: _ctx.detail.username
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          class: "w-6/12",
          label: "Kode Klien Parent",
          value: _ctx.detail.clientId
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-6/12",
          label: "Nomor Telepon Klien",
          value: _ctx.detail.clientPhone
        }, null, 8, ["value"])
      ]),
      _createVNode(_component_DataWrapper, {
        label: "Token",
        value: _ctx.detail.webhookToken
      }, null, 8, ["value"])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDate(_ctx.detail.createdAt)), 1),
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.detail.createdBy), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.detail.updatedAt)), 1),
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.detail.updatedBy), 1)
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_LpButton, {
          customClass: "px-1 sm:px-12 py-2.5 text-white",
          isWidthFull: "",
          onClick: _ctx.goToEdit,
          title: "Ubah"
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}